<script>
import 'bootstrap';
import Loader from '../components/Loader';
import Level from '../components/map/Level';
import Mission from '../components/map/Mission';
import 'bootstrap/dist/css/bootstrap.min.css';
import {MapClient} from '@/clients/MapClient';
import {attachCssFile} from "@/Helper";
import config from "@/composables/Config";
import {useI18n} from 'vue-i18n'

const mapBasePath = process.env.MAP_BASE_PATH;

export default {
    setup() {
        const {locale} = useI18n()

        function resetLocale(newLang) {
            locale.value = newLang.code;
            if (newLang.is_rtl) {
                document.documentElement.setAttribute('dir', 'rtl');
            } else {
                document.documentElement.setAttribute('dir', 'ltr');
            }
        }

        return {
            resetLocale
        }
    },

    components: {
        'level': Level,
        'loader': Loader,
        'mission': Mission
    },

    data() {
        return {
            mapSettings: {},
            mapName: null,
            mapResponse: [],
            dataLoaded: false,
            mapData: [],
            userProgress: null,
            userImage: null,
            progress: null,
            current: null,
            questUsers: null,
            localLanguage: '',
            documentReady: false,
            mapBasePath: mapBasePath,
        }
    },

    methods: {
        getMissionStatusCode(mission) {
            if (this.userProgress && this.userProgress.missions[mission.order] !== undefined) {
                return parseInt(this.userProgress.missions[mission.order]);
            }

            return 200;
        },
        createMap() {
            const token = this.$route.query.t
            if (typeof token !== "undefined") {
                let header = {
                    "authorization": "Bearer " + token
                };
                MapClient.getMapSettings(header).then((response) => {
                    this.mapSettings = response.data;
                    this.mapName = this.mapSettings.folder;
                    this.resetLocale(this.mapSettings.language)
                    attachCssFile(
                        `${mapBasePath}/maps/${this.mapName}/css/map`
                    );
                    MapClient.getMapQuest(header).then((response) => {
                        let mapResponse = response.data;
                        this.mapResponse = mapResponse.concat(this.mapData);
                        MapClient.getUserProgress(header).then((response) => {
                            this.userProgress = response.data;
                            this.userImage = this.userProgress.image;
                            this.progress = this.userProgress.progress == null ? parseInt('0.00') : this.userProgress.progress;
                            this.current = this.userProgress.current;
                            MapClient.getQuestUsers(header).then((questUsers) => {
                                this.questUsers = questUsers.data;
                                this.dataLoaded = true;
                                setTimeout(() => {
                                    this.documentReady = true;
                                }, 3000);
                            });
                        });
                    });
                });
            }
        },
        groupIntoChunks(items, size) {
            const result = [];
            for (let i = 0; i < items.length; i += size) {
                const item = items.slice(i, i + size);
                result.push(item);
            }
            return result;
        },
        calculateAndGetBlocksCount(number, missions) {
            let missionsCount = missions.length,
                blocks = [];
            if (missionsCount <= 10) {
                blocks = [{is_initial: true, missions}];
            } else if (number > 10) {
                let groupedChunks = this.groupIntoChunks(
                    missions,
                    10
                );
                for (let i = 0; i < groupedChunks.length; i++) {
                    let isInitial = false;
                    if (i === 0) {
                        isInitial = true;
                    }

                    blocks.push({
                        is_initial: isInitial,
                        missions: groupedChunks[i]
                    });
                }
            }

            return blocks;
        }
    },

    mounted() {
        // if (localStorage.getItem(config.general.token)) {
        //     localStorage.removeItem(config.general.token)
        // }
        this.createMap();
    }
}
</script>
<template>
    <div class='mq-map-view mq-map-view_01'>
        <div class='mq-map-view-loader' v-if='!documentReady'>
            <div class='mq-map-view-loader-inner'>
                <loader></loader>
            </div>
        </div>
        <div class='mq-map-view-inner' v-if='dataLoaded'>
            <div class='mq-map-view-opener is-mobile-img'
                 :style="`background: url(${mapBasePath}/maps/${mapName}/mobile/files/map_opener.png); background-size: contain;background-repeat: no-repeat;width: 100%;`">
                <img
                    :src="`${mapBasePath}/maps/${mapName}/mobile/files/map_opener.png`"
                    style='visibility: hidden;'>
            </div>
            <div class='mq-map-view-opener is-desktop-img'
                 style='background: none;background-size: contain;background-repeat: no-repeat;width: 100%;'>
                <img
                    :src="`${mapBasePath}/maps/${mapName}/desktop/files/mission_opener.png`">
            </div>
            <div class='mq-map-view-levels'>
                <div class='mq-map-view-level' v-for='(data, key) in mapResponse' v-bind:key='key'>
                    <div class='mq-map-view-level-missions'
                         v-for='(blockData, i) in calculateAndGetBlocksCount(data.missions.length, data.missions)'
                         v-bind:key="'key_' + key + i">
                        <div
                            :class="['mq-map-view-level-missions-block', 'mq-map-view-block-level-' + blockData.missions.length]">
                            <mission v-for='(mission, missionIndex) in blockData.missions' :blockData='blockData'
                                     :data='data' :mission='mission' :missionIndex='missionIndex'
                                     :missionStatusCode='getMissionStatusCode(mission)'
                                     :totalMissions='Object.keys(this.userProgress.missions).length' :mapName='mapName'
                                     :userImage='userImage' :progress='progress' :current='current'
                                     :questUsers='questUsers' :mapBasePath='mapBasePath'></mission>
                            <level :mapName='mapName' :blockData='blockData'></level>
                            <div v-if='blockData.is_initial' class='mq-map-mission-level-header'>
                                <div class='mq-map-mission-level-header-panel'>
                                    <span></span>
                                    <span></span>
                                </div>
                                <h1>
                                    {{ $tt('map_page__level') }} {{ key + 1 }}
                                </h1>
                                <h5>
                                    {{ data.name }}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class='mq-map-view-closer'>
                <img
                    :src="`${mapBasePath}/maps/${mapName}/mobile/files/mission_closer.png`"
                    class='is-mobile-img'>
                <img
                    :src="`${mapBasePath}/maps/${mapName}/desktop/files/mission_closer.png`"
                    class='is-desktop-img'>
            </div>
        </div>
    </div>
</template>


<style lang='scss'>
@import '../assets/scss/maps/map_01.scss';
</style>